export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'MK',
        name: 'Macedonian',
        normal: '`1234567890-=жљњертѕуиопшѓасдфгхјклчќзџцвбнм,./',
        shift: { 0: '~!„“’%‘&*()_+', 44: ';:?' },
        alt: { 16: '€', 24: 'Ђђ', 29: '[]', 35: 'Ћћ', 40: '@{}§' }
    })
}
